import { Content } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `LandingHeader`.
 */
export type LandingHeaderProps =
  SliceComponentProps<Content.DiscountHeaderSlice>;

/**
 * Component for "LandingHeader" Slices.
 */
const LandingHeader = ({ slice }: LandingHeaderProps): JSX.Element => {
  const {
    background: bgImage,
    title,
    description,
    go_to_slice: goToSlice,
    button_label: buttonLabel,
    logos_title,
    logos,
  } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="relative w-full h-full">
        <PrismicNextImage
          field={bgImage}
          className="h-[480px] opacity-40 xl:opacity-100 xl:h-full xl:w-full object-cover transform scale-x-[-1]"
        />
        <div className="absolute inset-0 flex flex-col max-w-screen-2xl">
          <div className="text-white xl:text-black w-full xl:w-1/2 pt-16 xl:pt-32 2xl:pt-48 px-4 pl-16">
            <PrismicRichText field={title} />
            <div className="text-white xl:text-black xl:pr-12 mt-6 text-base xl:text-lg mb-8 xl:mb-12">
              <PrismicRichText field={description} />
            </div>
            <PrismicNextLink
              href={`#${goToSlice}`}
              className="text-white xl:text-black font-semibold border-2 rounded-lg px-4 xl:px-6 py-2 xl:py-4 border-green-500"
            >
              <span>{buttonLabel}</span>
            </PrismicNextLink>
          </div>
        </div>
        <div className="hidden xl:block absolute bottom-0 left-0 right-0 bg-marquee-gradient backdrop-blur-[47.5px] w-full py-10">
          <div className="justify-between flex w-full px-16 max-w-screen-2xl">
            <div className="text-lg font-semibold text-white pt-5 pr-4">
              {logos_title}
            </div>
            <div className="flex justify-center items-center gap-8 flex-wrap">
              {logos.map(({ logo }, index) => {
                return <PrismicNextImage key={`logo_${index}`} field={logo} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHeader;
